import ErrorList from './ErrorList';
import InternalForm, { useForm } from './Form';
import Item from './FormItem';
import List from './FormList';
import { FormProvider } from './context';
const Form = InternalForm;
Form.Item = Item;
Form.List = List;
Form.ErrorList = ErrorList;
Form.useForm = useForm;
Form.Provider = FormProvider;
export default Form;
